import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down\"><path d=\"M12.158 6.592a.5.5 0 0 0-.656-.752l-.05.045L8 9.336 4.549 5.885a.5.5 0 0 0-.656-.045l-.051.045a.5.5 0 0 0-.045.656l.045.05 3.757 3.758c.205.205.526.22.748.048l.054-.048 3.757-3.757Z\" opacity=\".4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol